var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view view-goals"},[_c('div',{staticClass:"content"},[_c('div',{directives:[{name:"scrollbar",rawName:"v-scrollbar"}],staticClass:"scroll"},[_c('div',[_c('goals')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }